import { permissionsRequestsTyped } from "@/api/(requests)/permissionsTyped";
import type { UserPermissions, UUID } from "@/core/types";

export async function getUserPermissions(userId: UUID): Promise<UserPermissions> {
  return permissionsRequestsTyped.get_user_permissions({ urlParams: { userId } });
}
